module.exports = __webpack_public_path__ + "img/location-marker.0a744d7e.svg";